import { createSlice } from "@reduxjs/toolkit";

const initialUserProfileNewState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  allGames: [],
  detailedCoinSummary: {},
  NameList: [],
  currencyList: [],
  userInfo: {},
  // user: [],
  userContestList: [],
  tournamentLength: 0,
  popupDetails: null,
  popupLoading: false
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const UserProfileNewSlice = createSlice({
  name: "userProfileNew",
  initialState: initialUserProfileNewState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
      state.tournamentLength = 0;
      state.userContestList = [];
    },

    allGamesList: (state, action) => {
      const { allGames } = action.payload;
      state.listLoading = false;
      state.allGames = allGames;
    },
      PartnerList: (state, action) => {
      const { partnerList } = action.payload;
      state.listLoading = false;
      state.error = null;
     // state.totalCount = 0;
      state.partnerList = partnerList;
    },

    allContestList: (state, action) => {
      const { totalCount, allContestList, tournamentLength } = action.payload;
      state.totalCount = totalCount;
      state.error = null;
      state.listLoading = false;
      state.tournamentLength = tournamentLength;
      state.userContestList = allContestList;
    },
    usersLedgerReportList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    detailedCoinSummary: (state, action) => {
      console.log("action.paylod", action.payload);
      const { fetchDetailedCoinSummary } = action.payload;
      state.listLoading = false;
      state.detailedCoinSummary = fetchDetailedCoinSummary;
    },
    NameList: (state, action) => {
      const { totalCount, entities } = action.list;
      state.listLoading = false;
      state.error = null;
      state.totalCount = totalCount;
      state.NameList = entities;
  },
  currencyList: (state, action) => {
    const { currencyList } = action.payload;
    state.listLoading = false;
    state.error = null;
    state.currencyList = currencyList?.currencyData || [];
  },
  singleNameFetched: (state, action) => {
    state.actionsLoading = false;
    state.userInfo = action.payload?.userInfo;
    state.error = null;
  },
  currencyList: (state, action) => {
    const { currencyList } = action.payload;
    state.listLoading = false;
    state.error = null;
    state.currencyList = currencyList?.currencyData || [];
  },
  popupDetailFetched: (state, action) => {
    state.actionsLoading = false;
    state.popupLoading = false;
    state.popupDetails = action.payload?.popupDetails;
    state.error = null;
  },
  startPopupLoader: (state, action) => {
    state.popupLoading = true;
  },
  },
});
